module.exports = __webpack_public_path__ + "static/img/bcg.909e5bf6.webp";